import React, { useEffect, useRef, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  getAllCommissionHistoryAsync,
  CommissionHistoryActions,
} from "../redux";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import CommissionHistoryTable from "./commission_history_detail/commissionHistoryTable";
import DatePicker from "react-datepicker";

export function CommissionHistory() {
  const [showEditTemplate, setShowEditTemplate] = useState(false);
  const dispatch = useDispatch();
  const searchCommissionHistoryRef = useRef();
  const { refreshList, search, searchText, fromDate, toDate } = useSelector(
    (state) => state.commissionHistory,
    shallowEqual
  );

  // State for the selected filter values
  const [commissionType, setCommissionType] = useState("All");

  const commissionTypeOptions = [
    { value: "", label: "All" },
    { value: "BET", label: "Bet" },
    { value: "WITHDRAWAL", label: "Withdrawal" },
  ];

  // Call API while filters or search text changes

  useEffect(() => {
    if (searchCommissionHistoryRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(CommissionHistoryActions.refreshCommissionHistoryList());
        }
      };
      let input = searchCommissionHistoryRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(CommissionHistoryActions.searchTextChange(""));
        input.value = "";
      };
    }
  }, []);

  useEffect(() => {
    if (refreshList) {
      // Pass the selected filters to the API
      dispatch(
        getAllCommissionHistoryAsync({
          search,
          searchText,
          fromDate,
          toDate,
        })
      );
    }
  }, [refreshList]);

  const onEditClick = (email) => {
    setShowEditTemplate(true);
  };

  const resetChanges = () => {
    setCommissionType("All");
    dispatch(CommissionHistoryActions.resetFilters());
  };

  const handleToDateChange = (date) => {
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999); // Set time to end of the day
    dispatch(CommissionHistoryActions.toDateChanges(endOfDay));
  };
  const handleFromDateChange = (date) => {
    dispatch(CommissionHistoryActions.fromDateChanges(date));
  };

  const onSearchTextChange = (e) => {
    dispatch(CommissionHistoryActions.searchTextChange(e.target.value));
  };

  const onSelectChange = (key, setState) => (selectedOption) => {
    setState(selectedOption);

    dispatch(
      CommissionHistoryActions.selectTextChange({
        [key]: selectedOption, // Update only the specific key
      })
    );
  };

  return (
    <>
      <Card>
        <Row>
          <Col>
            <Card>
              <CardHeader title="Commission History"></CardHeader>
            </Card>
          </Col>
        </Row>
        <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
        <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
        <Row>
          <Col>
            <CardHeaderToolbar>
              <Row className="d-flex align-items-center justify-content-end gap-4">
                <Col lg={2} className="p-0">
                  <div style={{ margin: "1px" }} className="date-picker-input">
                    <DatePicker
                      selected={fromDate}
                      autoComplete="off"
                      placeholderText="From date"
                      onChange={(date) => handleFromDateChange(date)}
                      name="fromDate"
                      value={fromDate}
                      maxDate={new Date()}
                      dateFormat="MMM d, yyyy"
                    />
                  </div>
                </Col>
                <Col lg={2} className="p-0">
                  <div style={{ margin: "1px" }} className="date-picker-input">
                    <DatePicker
                      name="toDate"
                      placeholderText="To date"
                      autoComplete="off"
                      value={toDate}
                      dateFormat="MMM d, yyyy"
                      selected={toDate}
                      maxDate={new Date()}
                      onChange={(date) => handleToDateChange(date)}
                    />
                  </div>
                </Col>
                <Col lg={1} className="p-0">
                  <button
                    className="btn_new btn-sm filter-btn w-100"
                    type="button"
                    onClick={() => resetChanges()}
                  >
                    Reset
                  </button>
                </Col>

                {/* <Col lg={2} className="p-0 mr-2">
                  <div className="viral-events-dropdown"></div> */}

                  {/* Transaction Type Select */}
                {/* </Col> */}
                <Col lg={2} className="p-0 mr-2">
                  <div className="viral-events-dropdown">
                    <Select
                      value={commissionType}
                      placeholder="Commission Type"
                      className="border-0 p-0"
                      classNamePrefix="phoSelect"
                      options={commissionTypeOptions}
                      onChange={onSelectChange(
                        "commission_type",
                        setCommissionType
                      )}
                    />
                  </div>
                </Col>
                <form
                  autoComplete="off"
                  className="subheader_filter"
                  onSubmit={(e) => e.preventDefault()}
                >
                    <input
                      name="Search"
                      placeholder="Search. . ."
                      type="text"
                      className="form-control search-input"
                      value={searchText}
                      onChange={onSearchTextChange}
                      ref={searchCommissionHistoryRef}
                    />
                </form>
              </Row>
            </CardHeaderToolbar>
          </Col>
        </Row>
                      </div>
                      </div>
        <CommissionHistoryTable onEditClick={onEditClick} />
      </Card>
    </>
  );
}
